import React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import TooltipCommerceStore from 'components/TooltipCommerce';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import styles from './ItemVariantField.css';

const popoverFocus = ({ content }) => (
  <Popover id="purchaseOrder">{content}</Popover>
);

class ItemVariantField extends React.Component {
  render() {
    const {
      member,
      showDelete,
      isSalesTypePrice,
      isRecipe,
      index,
      ecommerceAttributes,
      itemVariants,
    } = this.props;
    if (ecommerceAttributes && index === -1) {
      return (
        <div className="mk-grouped-input">
          <div
            className={`form-group ${
              isSalesTypePrice ? 'col-sm-6' : 'col-sm-4'
            }`}
          >
            <div
              className={`panel-heading ${styles['panel-head']} ${
                styles['panel-head-first']
              }`}
            >
              <label>Variant Name</label>
            </div>
          </div>
          {!isSalesTypePrice && (
            <div
              className={`form-group col-sm-4 no-padding-left no-padding-right`}
            >
              <div className={`panel-heading ${styles['panel-head']}`}>
                <TooltipCommerceStore
                  placement="top"
                  delay={200}
                  name={'basePrice'}
                >
                  <label>
                    Price Per Variant
                    <span
                      className={`glyphicon glyphicon-info-sign ${
                        styles['icon-container']
                      }`}
                    />
                  </label>
                </TooltipCommerceStore>
              </div>
            </div>
          )}
          <div
            className={`form-group ${
              isSalesTypePrice ? 'col-sm-6' : 'col-sm-4'
            }`}
          >
            <div className={`panel-heading ${styles['panel-head']}`}>
              <TooltipCommerceStore placement="top" delay={200} name={'sku'}>
                <label>
                  SKU
                  <span
                    className={`glyphicon glyphicon-info-sign ${
                      styles['icon-container']
                    }`}
                  />
                </label>
              </TooltipCommerceStore>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="mk-grouped-input">
        <div
          className={`form-group ${isSalesTypePrice ? 'col-sm-6' : 'col-sm-4'}`}
        >
          <Field
            name={`${member}.name`}
            dis={itemVariants[index].is_generated}
            component={SettingField}
            className="form-control"
            placeholder="Variant Name"
          />
        </div>
        {!isSalesTypePrice && (
          <div
            className={`form-group col-sm-4 ${ecommerceAttributes &&
              'no-padding-left no-padding-right'}`}
          >
            <Field
              name={`${member}.price`}
              component={SettingField}
              inputClassName="text-right"
              positiveNumberOnly
              placeholder="Rp. 0"
            />
          </div>
        )}
        <div
          className={`form-group ${isSalesTypePrice ? 'col-sm-6' : 'col-sm-4'}`}
        >
          <Field
            name={`${member}.sku`}
            component={SettingField}
            className={`form-control ${styles['text-align-last-right']}`}
            placeholder="SKU"
            feedbackClassName={`${styles.feedback}`}
            inputClassName={`${styles['last-input']}`}
          />
          {showDelete && !isRecipe && (
            <div className={`${styles['btn-delete-wrapper']}`}>
              <span
                className={`${
                  ecommerceAttributes
                    ? styles['btn-delete-ecommerce']
                    : styles['btn-delete']
                } `}
                onClick={this._onDelete}
                type="button"
              >
                <i className="fa fa-times-circle" />
              </span>
            </div>
          )}
          {isRecipe && (
            <OverlayTrigger
              placement="top"
              overlay={popoverFocus({
                content:
                  'The item variant cannot be deleted because it has been associated with a Recipe. Please first delete the Recipe and try again.',
              })}
            >
              <div className={`${styles['btn-delete-wrapper']}`}>
                <span className={`${styles['btn-warning']}`} type="button">
                  <i className="fa fa-exclamation-circle" />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </div>
    );
  }

  _onDelete = () => {
    this.props.onDelete();
  };
}

const selector = formValueSelector('modal_item_variants');

function mapStateToProps(state) {
  return {
    itemVariants: selector(state, 'item_variants'),
  };
}

ItemVariantField.propTypes = {
  member: PropTypes.object,
  onDelete: PropTypes.func,
};

export default connect(mapStateToProps)(ItemVariantField);
